export default "__VITE_ASSET__DGo874Dh__"